import defaultProfileImage from '@atom/images/defaultProfileImage.png';
import { Icon } from '@atom/mui';
import colors from '@atom/styles/colors';
import { History } from '@atom/types/history';
import { setDisplayDate } from '@atom/utilities/timeUtilities';

import classes from './history.module.css';

export interface Props {
  history: History;
}

const NEWLINE_TOKEN = '/newline/';

const tokens = {
  '/startbold/': '<strong>',
  '/endbold/': '</strong>',
};

export const renderMessage = (message: string) => {
  const parsed = Object.entries(tokens).reduce((acc, [key, value]) => {
    const regex = new RegExp(key, 'g');
    return acc.replace(regex, value);
  }, message);

  return parsed
    .split(NEWLINE_TOKEN)
    .map(section => `<div>${section}</div>`)
    .join('');
};

const HistoryItem = ({ history }: Props) => {
  const deviceIcon =
    history.device !== 'desktop' ? (
      <Icon color={colors.neutral.gray}>phone_iphone</Icon>
    ) : (
      <div />
    );

  return (
    <div className={classes.historyItemContainer}>
      <div className={classes.historyItemHeader}>
        <div className={classes.historyItemHeaderItem}>
          <img
            className={classes.profileImage}
            src={history.user.photoUrl}
            onError={(error: any) => {
              error.target.src = defaultProfileImage;
            }}
          />
          <div
            className={classes.userName}
          >{`${history.user.firstName} ${history.user.lastName}`}</div>
        </div>
        <div className={classes.historyItemHeaderItem}>
          {deviceIcon}
          <div className={classes.historyDate}>
            {setDisplayDate(history.date)}
          </div>
        </div>
      </div>
      <div
        className={classes.historyMessage}
        dangerouslySetInnerHTML={{
          __html: renderMessage(history.message),
        }}
      />
    </div>
  );
};

export default HistoryItem;
